import React from 'react'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { TimeClocksMain } from './components/TimeClocksMain'
import { TimeClocksProvider } from './context/TimeClocksProvider'
import { TimeClocksWorkflowsProvider } from './context/TimeClocksWorkflowsProvider'
import { CreateTimeClockFlow } from './workflows/CreateTimeClockFlow'
import { DeleteTimeClockFlow } from './workflows/DeleteTimeClockFlow'

export const TimeClocks = () => {
  return (
    <NuqsAdapter>
      <TimeClocksProvider>
        <TimeClocksWorkflowsProvider>
          <TimeClocksMain />
          <CreateTimeClockFlow />
          <DeleteTimeClockFlow />
        </TimeClocksWorkflowsProvider>
      </TimeClocksProvider>
    </NuqsAdapter>
  )
}
